import { render } from "./LinksSection.vue?vue&type=template&id=3981b904"
import script from "./LinksSection.vue?vue&type=script&lang=js"
export * from "./LinksSection.vue?vue&type=script&lang=js"

import "./LinksSection.vue?vue&type=style&index=0&id=3981b904&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__